import { MUIDataTableMeta } from 'mui-datatables';
import en from '../../../assets/language/en.json';
import de from '../../../assets/language/de.json';
import { commonOptions } from './common.datatable.options';

const actionNameColumns = [
    ...commonOptions.indexColumn,
    {
        name: 'id',
        label: en.id,
        options: {
            display: false,
            sort: false,
            filter: false,
        },
    },
    {
        name: 'nameEn',
        label: en.name,
        options: {
            filter: true,
            sort: true,
        },
    },
    {
        name: 'nameDe',
        label: de.name,
        options: {
            filter: true,
            sort: true,
        },
    },

    ...commonOptions.objectTimestamps,
];

export const actionNameDataTables = {
    actionNameColumns,
};
